import { render, staticRenderFns } from "./DataIndex.vue?vue&type=template&id=5808c199&scoped=true&"
import script from "./DataIndex.vue?vue&type=script&lang=js&"
export * from "./DataIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808c199",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5808c199')) {
      api.createRecord('5808c199', component.options)
    } else {
      api.reload('5808c199', component.options)
    }
    module.hot.accept("./DataIndex.vue?vue&type=template&id=5808c199&scoped=true&", function () {
      api.rerender('5808c199', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/uform/DataIndex.vue"
export default component.exports